import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MissingDataRecordRefFragment = { __typename?: 'RecordRef', entityType: Types.MissingDataEntityType, id: string, label: string, parentId?: string | null };

export type MissingDataFindingFragment = { __typename?: 'MissingDataFinding', key: string, code: Types.MissingDataCode, subject: { __typename?: 'RecordRef', entityType: Types.MissingDataEntityType, id: string, label: string, parentId?: string | null }, fixAt: { __typename?: 'RecordRef', entityType: Types.MissingDataEntityType, id: string, label: string, parentId?: string | null } };

export type GetMissingDataFindingsQueryVariables = Types.Exact<{
  entityType: Types.MissingDataEntityType;
  subjectIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  codes?: Types.InputMaybe<Array<Types.MissingDataCode> | Types.MissingDataCode>;
  includeIgnored?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetMissingDataFindingsQuery = { __typename?: 'Query', missingDataFindings: Array<{ __typename?: 'MissingDataFinding', key: string, code: Types.MissingDataCode, subject: { __typename?: 'RecordRef', entityType: Types.MissingDataEntityType, id: string, label: string, parentId?: string | null }, fixAt: { __typename?: 'RecordRef', entityType: Types.MissingDataEntityType, id: string, label: string, parentId?: string | null } }> };

export const MissingDataRecordRefFragmentDoc = new TypedDocumentString(`
    fragment MissingDataRecordRef on RecordRef {
  entityType
  id
  label
  parentId
}
    `, {"fragmentName":"MissingDataRecordRef"});
export const MissingDataFindingFragmentDoc = new TypedDocumentString(`
    fragment MissingDataFinding on MissingDataFinding {
  key
  code
  subject {
    ...MissingDataRecordRef
  }
  fixAt {
    ...MissingDataRecordRef
  }
}
    fragment MissingDataRecordRef on RecordRef {
  entityType
  id
  label
  parentId
}`, {"fragmentName":"MissingDataFinding"});
export const GetMissingDataFindingsDocument = new TypedDocumentString(`
    query GetMissingDataFindings($entityType: MissingDataEntityType!, $subjectIds: [ID!]!, $codes: [MissingDataCode!], $includeIgnored: Boolean) {
  missingDataFindings(
    entityType: $entityType
    subjectIds: $subjectIds
    codes: $codes
    includeIgnored: $includeIgnored
  ) {
    ...MissingDataFinding
  }
}
    fragment MissingDataRecordRef on RecordRef {
  entityType
  id
  label
  parentId
}
fragment MissingDataFinding on MissingDataFinding {
  key
  code
  subject {
    ...MissingDataRecordRef
  }
  fixAt {
    ...MissingDataRecordRef
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetMissingDataFindings: build.query<GetMissingDataFindingsQuery, GetMissingDataFindingsQueryVariables>({
      query: (variables) => ({ document: GetMissingDataFindingsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetMissingDataFindingsQuery, useLazyGetMissingDataFindingsQuery } = injectedRtkApi;
